var fonts = {
  euclid: "Euclid, Arial, sans-serif",
  graphik: "Graphik, Arial, sans-serif",
  matter: "Matter, Arial, sans-serif"
};
export { fonts as default };